import React from "react";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  IconButton,
  Link as MuiLink,
} from "@mui/material";
import { Facebook, Instagram, Twitter, GitHub } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box sx={{ bgcolor: "#1F2937", color: "#9CA3AF", mt: 4, pl: 5 }}>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          pt: 4,
        }}
      >
        <Grid item sm={10}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={7}>
              <Grid container spacing={2}>
                {/* Company Section */}
                <Grid item xs={6} sm={4} md={4}>
                  <Typography variant="h6" gutterBottom>
                    COMPANY
                  </Typography>
                  <Typography>About</Typography>
                  <Typography>Blog</Typography>
                  <Typography>Jobs</Typography>
                  <Typography>Press</Typography>
                  <Typography>Partners</Typography>
                </Grid>

                {/* Legal Section */}
                <Grid item xs={6} sm={4} md={4}>
                  <Typography variant="h6" gutterBottom>
                    LEGAL
                  </Typography>
                  <Typography>Claim</Typography>
                  <MuiLink href="/privacy-policy" underline="hover">
                    <Typography variant="body2" color="#9CA3AF">
                      Privacy
                    </Typography>
                  </MuiLink>

                  <MuiLink href="/terms-and-conditions" underline="hover">
                    <Typography variant="body2" color="#9CA3AF">
                      Terms
                    </Typography>
                  </MuiLink>
                </Grid>

                {/* Contact Section */}
                <Grid item xs={12} sm={4} md={4}>
                  <Typography variant="h6" gutterBottom>
                    CONTACT
                  </Typography>
                  <Typography>Email</Typography>
                  <Typography>Address</Typography>
                  <Typography>Phone number</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={11} sm={4}>
              {/* Newsletter Section */}
              <Grid item xs={12} sm={10}>
                <Typography variant="h6" gutterBottom>
                  SUBSCRIBE TO OUR NEWSLETTER
                </Typography>
                <Typography gutterBottom>
                  The latest news, articles, and resources, sent to your inbox
                  weekly.
                </Typography>
                <Box display="flex" mt={1}>
                  <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Enter your email"
                    sx={{ bgcolor: "#FFFFFF", flexGrow: 1, borderRadius: 1 }}
                  />
                  <Button
                    variant="contained"
                    sx={{ ml: 1, bgcolor: "#6B21A8" }}
                  >
                    Subscribe
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={11}>
              <Box
                mt={4}
                borderTop={1}
                borderColor="#3A3D44"
                pt={2}
                display="flex"
              >
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={8}>
                    <Typography>© 2025 D'Ajoo. All rights reserved.</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box>
                      <IconButton color="inherit">
                        <Facebook />
                      </IconButton>
                      <IconButton color="inherit">
                        <Instagram />
                      </IconButton>
                      <IconButton color="inherit">
                        <Twitter />
                      </IconButton>
                      <IconButton color="inherit">
                        <GitHub />
                      </IconButton>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
